<template>
 

  <q-btn :disabled="sector.cantidad == 0" block :class="get_clase(sector)" v-for="sector in props.sectores"
    @click="seleccionar_sector(sector)" :key="sector.id">
    <div class="col-12 col-sm-4">{{ sector.nombre }}</div>
    <div class="col-12 col-sm-4">{{ store.obtener_pesos(sector.precio) }}</div>
    <div class="col-12 col-sm-4">
      <div v-if="sector.cantidad != 0">
        SELECCIONAR
        <q-icon size="sm" :name="(sector.tiene_ubicacion == true) ? 'chair' : 'confirmation_number'" />
        <q-icon name="arrow_forward" />
      </div>
      <div v-else>
        AGOTADO
        <q-icon size="sm" name="close" />
      </div>
    </div>
  </q-btn>
</template>

<script setup>
// @ is an alias to /src
import { useRouter } from "vue-router";
import { ref,defineEmits } from "vue";
import { useEPStore } from "@/store/store";
import axios from "axios";


const store = useEPStore();
const router = useRouter();
const props = defineProps(["sectores"]);
const sin_ubicacion = ref(false);
const con_ubicacion = ref(false);
const sectorActual = ref(null);
const cantidad_entradas = ref(1);
const loading = ref(false);
const errores = ref(false);
const mensaje = ref("");
const seccion = ref({})
const boton_carrito_desactivado = ref(true);
const emit = defineEmits(['seleccionar_sector'])

function seleccionar_sector(sector) {
  // sectorActual.value = sector;
  // if (sector.tiene_ubicacion == true) {
  //   seccion.value = sector;
  //   con_ubicacion.value = true;
  // } else {
  //   sin_ubicacion.value = true;

  // }
  emit("seleccionar_sector",sector);
}

// function cerrar_dialogo() {
//   dialog.value = false;
// }

function get_clase(sector) {
  let clase = ["bg-orange-9","full-width", "col-12" , "q-ma-md"  , "row"  ,"text-white","text-center","text-weight-bold"];
  if (sector.cantidad == 0) {
    clase.push("bg-grey-9");
  }
  return clase;
}

</script>
